import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { DropdownOpenIcon } from "../Icon/DropdownOpenIcon";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { Box, SxProps } from "@mui/material";
import { UICollapse } from "../BuildlingBlocks/UICollapse";

export interface PropertyEditorCollapsableSectionInterface {
    label?: string;
    startOpen: boolean;
    renderUI: () => JSX.Element;
    editObject: object;
    onChange?: () => void;
    sx?: SxProps;
}

export const PropertyEditorCollapsableSection: React.FC<PropertyEditorCollapsableSectionInterface> = (
    props: PropertyEditorCollapsableSectionInterface,
) => {
    const [open, setOpen] = useState<boolean>(props.startOpen);

    useEffect(() => {
        setOpen(props.startOpen);
    }, [props.startOpen]);

    return (
        <PropertyEditorSectionRender sx={props.sx}>
            <HeaderRender>
                {props.label && <Label>{props.label}</Label>}
                <ActionRender
                    open={open}
                    onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                        event.stopPropagation();
                        setOpen(!open);
                        StateManager.changed(props.editObject);
                        if (props.onChange) props.onChange();
                    }}
                >
                    <DropdownOpenIcon />
                </ActionRender>
            </HeaderRender>
            <UICollapse in={open}>
                <ObserveState
                    listenTo={props.editObject}
                    control={() => {
                        return <PropertyEditorSectionBody>{props.renderUI()}</PropertyEditorSectionBody>;
                    }}
                />
            </UICollapse>
        </PropertyEditorSectionRender>
    );
};

const PropertyEditorSectionRender = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const HeaderRender = styled.div`
    display: flex;
`;

const Label = styled.label`
    font-size: 14px;
`;

const ActionRender = styled.div<{ open: boolean }>`
    margin-left: auto;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    ${(props) => props.open && `transform: rotate(180deg);`}
`;

const PropertyEditorSectionBody = styled.div`
    display: flex;
    flex-direction: column;

    > * {
        margin-bottom: 10px !important;
    }
`;
